<template>
  <b-form-group
    :id="id"
    :content-cols="contentCols"
    :content-cols-lg="contentColsLg"
    :content-cols-md="contentColsMd"
    :content-cols-sm="contentColsSm"
    :content-cols-xl="contentColsXl"
    :description="description"
    :disabled="disabled"
    :feedback-aria-live="feedbackAriaLive"
    :invalid-feedback="invalidFeedback"
    :label="label"
    :label-align="labelAlign"
    :label-align-lg="labelAlignLg"
    :label-align-md="labelAlignMd"
    :label-align-sm="labelAlignSm"
    :label-align-xl="labelAlignXl"
    :label-class="labelClass"
    :label-cols="labelCols"
    :label-cols-lg="labelColsLg"
    :label-cols-md="labelColsMd"
    :label-cols-sm="labelColsSm"
    :label-cols-xl="labelColsXl"
    :label-for="labelFor"
    :label-size="labelSize"
    :label-sr-only="labelSrOnly"
    :state="state"
    :tooltip="tooltip"
    :valid-feedback="validFeedback"
    :validated="validated"
  >
    <slot
      :set-input-length="newValue => inputLength = newValue.length"
      :input-remaining="maxInputLength ? maxInputLength - inputLength : inputLength"
      :limit-input="value => {
        if (maxInputLength) {
          return value ? value.substring(0, maxInputLength) : null;
        }
        return value;
      }"
    />
  </b-form-group>
</template>
<script>
import { BFormGroup } from 'bootstrap-vue';

export default {
  name: 'MFormGroup',
  components: {
    BFormGroup,
  },
  props: {
    contentCols: {
      type: [Boolean, Number, String],
      default: null,
    },
    contentColsLg: {
      type: [Boolean, Number, String],
      default: null,
    },
    contentColsMd: {
      type: [Boolean, Number, String],
      default: null,
    },
    contentColsSm: {
      type: [Boolean, Number, String],
      default: null,
    },
    contentColsXl: {
      type: [Boolean, Number, String],
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    feedbackAriaLive: {
      type: String,
      default: 'assertive',
    },
    id: {
      type: String,
      default: null,
    },
    invalidFeedback: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    labelAlign: {
      type: String,
      default: null,
    },
    labelAlignLg: {
      type: String,
      default: null,
    },
    labelAlignMd: {
      type: String,
      default: null,
    },
    labelAlignSm: {
      type: String,
      default: null,
    },
    labelAlignXl: {
      type: String,
      default: null,
    },
    labelClass: {
      type: [Array, Object, String],
      default: null,
    },
    labelCols: {
      type: [Boolean, Number, String],
      default: null,
    },
    labelColsLg: {
      type: [Boolean, Number, String],
      default: null,
    },
    labelColsMd: {
      type: [Boolean, Number, String],
      default: null,
    },
    labelColsSm: {
      type: [Boolean, Number, String],
      default: null,
    },
    labelColsXl: {
      type: [Boolean, Number, String],
      default: null,
    },
    labelFor: {
      type: String,
      default: null,
    },
    labelSize: {
      type: String,
      default: null,
    },
    labelSrOnly: {
      type: Boolean,
      default: false,
    },
    state: {
      type: Boolean,
      default: null,
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    validFeedback: {
      type: String,
      default: null,
    },
    validated: {
      type: Boolean,
      default: false,
    },
    maxInputLength: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      inputLength: 0,
    };
  },
};
</script>
